enum BillingDailyFilterType {
  NONE = 'NONE',
  BILLING_DAILY = 'BILLING_DAILY',
  BILLING_COMPETENCE = 'BILLING_COMPETENCE',
}

const billingDailyFilterTypeOptions = [
  { text: 'Todos', value: BillingDailyFilterType.NONE },
  { text: 'Faturamento diário', value: BillingDailyFilterType.BILLING_DAILY },
  { text: 'Faturamento por competência', value: BillingDailyFilterType.BILLING_COMPETENCE },
];

export {
  BillingDailyFilterType,
  billingDailyFilterTypeOptions,
}
